import {IActionModel} from "../../shared/models/action.model";
import {GET_AUTH_CASES_LIST, SET_AUTH_CASES_LIST} from "../actions/dashboard.action";


export interface IDashboardReducerState {
    isAuthCasesListLoading: boolean;
    isAuthCasesListLoaded: boolean;
    authAllCasesList: any[];
}

const initialData: IDashboardReducerState = {
    isAuthCasesListLoading: false,
    isAuthCasesListLoaded: false,
    authAllCasesList: [],
}

const DashboardReducer = (state = initialData, action: IActionModel): IDashboardReducerState => {
    switch (action.type) {
        case GET_AUTH_CASES_LIST:
            state = {
                ...state,
                isAuthCasesListLoading: false,
                isAuthCasesListLoaded: false,
            }
            return state;
        case SET_AUTH_CASES_LIST:
            state = {
                ...state,
                isAuthCasesListLoading: false,
                isAuthCasesListLoaded: true,
                authAllCasesList: action.payload.authAllCasesList
            }
            return state;
        default:
            return state;
    }

}

export default DashboardReducer;
